import script from "./WeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./WeIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__